import React from 'react'

const Footer = () => {
  return (
    <div className='footer'>Value Added Coating Solution Pvt Ltd</div>
  )
}

export default Footer